import LoginForm from "./login.view";
import { useNavigate } from "react-router";
import PATHS from "../../constants/paths";
import * as UserServices from "../../services/UserServices";

const LoginContainer = () => {
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    const result = await UserServices.checkSso();
    if (result && result === "OK") {
      UserServices.profile().then((result) => {
        if (result && result.roles) {
          navigate(PATHS.FORM);
        }
      });
    } else {
      window.location.href = `${process.env.REACT_APP_LOGIN_URI}`;
    }
  };

  return <LoginForm gotoLogin={handleSubmit}></LoginForm>;
};

export default LoginContainer;
